module.exports = __webpack_public_path__ + "static/media/20190808_133759.0e4285f5.png";